import Template from '../Template/Template.component';

import { Layout } from './Layout';
import { TProps } from './Default.types';

const Default = (props: TProps) => <Template {...props} Layout={Layout} />;

export default Default;
